import { env } from 'utils/env';

const url = env.REACT_APP_LEASING_API_URL;

export const buildSecurityExportDownloadUrl = async (filePath, fileName, accessToken) =>
  `${url}/security/export-security-list/file/${encodeURIComponent(filePath)}/${encodeURIComponent(fileName)}?access_token=${accessToken}`;

export const buildExportUserRightsDetailsDownloadUrl = async (filePath, fileName, accessToken) =>
  `${url}/security/export-user-rights-details/file/${encodeURIComponent(filePath)}/${encodeURIComponent(
    fileName
  )}?access_token=${accessToken}`;
